import request from '@/utils/request';

export function getSeckillIndex(params) {
  return request({
    url: '/Seckill/index',
    params,
  });
}

export function doSeckill(targetType, targetId) {
  return request({
    url: '/Seckill/doSeckill',
    method: 'POST',
    data: {
      targetType,
      targetId,
    },
  });
}

export function getSeckillRemindUrl(params) {
  return request({
    url: '/Seckill/remind',
    params,
  });
}


export function bookSeckillWithMobile(data) {
  return request({
    url: '/Seckill/bookWithMobile',
    method: 'POST',
    data,
  });
}
